import csiCard from "csi/card/_base";
import csi from "csi/main";
import csiPrefs from "csi/prefs/_base";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import _ from "lodash";
import FilterAttributesTable from "./FilterAttributesTable";
import _AttributeDeleteMixin from "../Attributes/_AttributeDeleteMixin";
import { FILTER_ATTRIBUTES_CONTAINER_URL } from "csi/service/filterAttributeService";

const FilterAttributesDeleteController = declare(_AttributeDeleteMixin, {

	/**
	 * @override
	 * Delete key from key container.
	 * If it doesn't exist, assume we are trying to unlink cards.
	 */
	toWriter(): void {
		const widget = this.widget as typeof FilterAttributesTable.prototype;

		// get key container url
		const keyContainerUrl = widget.getKeyContainerUrl();

		// get node with key to delete
		const deleteNode = this.getNode();

		// check to see if preference view exists for these keys
		if (this.m_cache.get(keyContainerUrl)) {
			this.m_writer
				.changeNode(keyContainerUrl)
				.changeAttribute("Keys", xml.ATTR_STRINGMAP, { 0: deleteNode.Key }, false, true);
		} else {
			const { typeClass } = widget;

			// if there was no view found, need to augment from attribute specs
			const cardSpecs = csiCard.getAttributeCardSpecs(typeClass);

			const attributeKeysFromCardMinusDeletedKey = _.map(cardSpecs.attributeSpecs, (spec) => {
				return spec.key.toString();
			}).filter((key) => key !== deleteNode.Key);

			const attributeKeys = [];
			const keys = csi.hashArray(attributeKeysFromCardMinusDeletedKey, (key, i) => {
				attributeKeys.push(i);
				return i;
			});

			// create custom view
			this.m_writer.createNode(keyContainerUrl, csiPrefs.TYPE_VIEW, null, null, true)
				.changeAttribute("Attributes", xml.ATTR_STRINGVECTOR, attributeKeys)
				.changeAttribute("Keys", xml.ATTR_STRINGMAP, keys)
				.changeAttribute("TargetClass", xml.ATTR_STRING, typeClass)
				.attach(FILTER_ATTRIBUTES_CONTAINER_URL, csiPrefs.ATTR_PREFERENCES);
		}
	},
});

export = FilterAttributesDeleteController;